// jsdom seals window.location; this seam keeps navigation assertable.
const hardNavigate = (url: string): void => {
  window.location.href = url
}

export default hardNavigate
